import React from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import PlannedEventCard from './PlannedEventCard';
import { PlannedRecurringEvent } from '../../types/plannedEvents';
import { translateDayOfWeek } from '../../services/plannedEventService';

interface DayColumnProps {
  day: string; // English day name (e.g., 'Monday')
  events: PlannedRecurringEvent[];
  onEditEvent: (event: PlannedRecurringEvent) => void;
  onDeleteEvent: (plannedEventId: string) => void;
  onParticipantClick: (userId: string) => void;
  onParticipantDrop?: (eventId: string, userId: string) => void;
  onParticipantRemove?: (eventId: string, userId: string) => void;
}

const DayColumn: React.FC<DayColumnProps> = ({
  day,
  events,
  onEditEvent,
  onDeleteEvent,
  onParticipantClick,
  onParticipantDrop,
  onParticipantRemove,
}) => {
  const dayNameHu = translateDayOfWeek(day);

  return (
    <Paper
      elevation={2}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 500,
        overflow: 'hidden',
      }}
    >
      {/* Day Header - Sticky */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          p: 2,
          textAlign: 'center',
          zIndex: 10,
          borderRadius: '4px 4px 0 0',
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {dayNameHu.toUpperCase()}
        </Typography>
      </Box>

      <Divider />

      {/* Events List */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {events.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 200,
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Nincs tervezett esemény erre a napra
            </Typography>
          </Box>
        ) : (
          events.map((event) => (
            <PlannedEventCard
              key={event.plannedEventId}
              event={event}
              onEdit={() => onEditEvent(event)}
              onDelete={() => onDeleteEvent(event.plannedEventId)}
              onParticipantClick={onParticipantClick}
              onParticipantDrop={onParticipantDrop}
              onParticipantRemove={onParticipantRemove}
            />
          ))
        )}
      </Box>
    </Paper>
  );
};

export default DayColumn;
